(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodStatusLabel', sodStatusLabel);

    function sodStatusLabel() {
        return {
            restrict: 'E',
            controller: sodStatusLabelCtrl,
            scope: {
                statusText:'=',
                statusKey: '=?'
            },
            controllerAs: 'vm',
            bindToController: true,
            template: '<span class="sod-label" ng-bind="vm.statusText" ng-class="vm.statusKey"></span>'
        };
    }

    function sodStatusLabelCtrl() {}
})();